import Images from 'assets/images';
import classes from './Profile.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'setup/store';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useAppActions } from 'actions/app-actions';
import { useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function Profile() {
  const { t } = useTranslation();
  const userProfile = useAppSelector((state) => state.appReducer.loggedInUser);
  const roleIdMap = useAppSelector((state) => state.userReducer.roleIdMap);
  const { logoutUser } = useAppActions();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleLogout = async () => {
    await logoutUser();
    handleClose();
  };

  const _handlePwdChange = async () => {
    handleClose();
    navigate('/change-password');
  };

  return (
    <div className={classes.profile}>
      <div className={classes.profile__avatar}>
        <AccountCircleIcon color="primary" />
      </div>
      <div className={classes.profile__info}>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <Box display="flex" flexDirection="column">
            <span className={classes.profile__userName}>{userProfile?.displayName}</span>
            <span className={classes.profile__role}>
              {roleIdMap && userProfile ? roleIdMap[userProfile?.roleId].displayName : ''}
            </span>
          </Box>
        </Button>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem>
          <div>
            <span className={classes.profile__role}>
              {roleIdMap && userProfile ? roleIdMap[userProfile?.roleId].displayName : ''}
            </span>
          </div>
        </MenuItem>
        <MenuItem onClick={_handlePwdChange}>Change Password</MenuItem>
        <MenuItem onClick={_handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
}

export default Profile;
